import { ContentItemType } from './ContentItemType';
import { ReadOnly } from 'module/Common';

export type ContentError = ReadOnly<ContentError.Shape>;

export namespace ContentError {
  export interface Shape {
    type: ContentItemType;
    error: Error | null;
  }

  export function create(error: Error | null = null): ContentError {
    return { error, type: ContentItemType.Error };
  }
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/ContentError.ts